import { render, staticRenderFns } from "./MobileContact.vue?vue&type=template&id=869ba916&lang=pug"
import script from "./MobileContact.vue?vue&type=script&lang=js"
export * from "./MobileContact.vue?vue&type=script&lang=js"
import style0 from "./MobileContact.vue?vue&type=style&index=0&id=869ba916&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports